/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/button-has-type */
import React, { useContext, useEffect, useState } from 'react';

import { CardContent, Divider, Card, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import copy from 'copy-to-clipboard';

import { GeneralContext } from '../../core/app-context/GeneralContext';
import { Translator } from '../../core/i18n/translator';
import { ButtonPrimary } from '../../shared/components';
import FormAddress from './components/FormAddress';
import FormStore from './components/FormStore';
import FormUser from './components/FormUser';
import { useChangePasswordEmail } from './hooks/use-change-password-email';
import { useDeactivateUserAccount } from './hooks/use-deactivate-user-account';
import { useGetStoreInfo } from './hooks/use-get-store-info';
import { useStoreForm } from './hooks/use-store-form';
import { useUserForm } from './hooks/use-user-form';
import { useUpdateStore } from './hooks/use-update-store';
import { useUpdateUser } from './hooks/use-update-user';
import { Container, DivActions, DivLinkCopy, FormsDiv } from './styles';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Profile() {
  const { setSideMenu, setIdMenuSelected, store, setStore, user, setUser } =
    useContext(GeneralContext);
  const userId = user?.id;
  const { deactivateUserAccount } = useDeactivateUserAccount();
  const { changePasswordEmail } = useChangePasswordEmail();
  const {
    formState,
    setFormState,
    formError,
    setInitialFormState,
    resetForm,
    validateForm,
    mapStoreToFormState,
    cleanFormState,
  } = useStoreForm();

  const {
    formState: userFormState,
    setFormState: setUserFormState,
    formError: userFormError,
    setInitialFormState: setUserInitialFormState,
    resetForm: resetUserForm,
    validateForm: validateUserForm,
    mapUserToFormState,
    cleanFormState: cleanUserFormState,
  } = useUserForm();

  const { updateStore, success: isStoreUpdated } = useUpdateStore();
  const { updateUser, success: isUserUpdated } = useUpdateUser();

  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogChangePassword, setOpenDialogChangePassword] =
    useState(false);

  const changeValue = (field, value) => {
    setFormState({
      ...formState,
      [field]: value,
    });
  };

  const changeUserValue = (field, value) => {
    setUserFormState({
      ...userFormState,
      [field]: value,
    });
  };

  useEffect(() => {
    setSideMenu('profile');
    setIdMenuSelected('profile');
  }, [setSideMenu]);

  useEffect(() => {
    if (store) {
      mapStoreToFormState(store);
    }
  }, [store]);

  useEffect(() => {
    if (user) {
      mapUserToFormState(user);
    }
  }, [user]);

  useEffect(() => {
    if (isStoreUpdated) {
      setInitialFormState(formState);
      // Updates the store context
      setStore({ ...store, ...formStateToGraphqlArgs(formState) });
    }
  }, [isStoreUpdated]);

  useEffect(() => {
    if (isUserUpdated) {
      setUserInitialFormState(userFormState);
      // Updates the user context
      setUser({ ...user, ...userFormState });
    }
  }, [isUserUpdated]);

  function formStateToGraphqlArgs(formStateValue) {
    return {
      name: formStateValue.name,
      email: formStateValue.email,
      cnpj: formStateValue.cnpj,
      telephone: formStateValue.telephone,
      websiteUrl: formStateValue.websiteUrl,
      monthlyOrders: formStateValue.monthlyOrders,
      timezone: formStateValue.timezone,
      imageUrl: formStateValue.imageUrl,
      address: {
        street: formStateValue.addrStreet,
        number: formStateValue.addrNumber,
        complement: formStateValue.addrComplement,
        district: formStateValue.addrDistrict,
        city: formStateValue.addrCity,
        state: formStateValue.addrState,
        zipCode: formStateValue.addrZipCode,
      },
    };
  }
  return (
    <Container>
      <FormsDiv>
        <h1>
          {Translator('profile.title')} {}
        </h1>
        <Card style={{ maxWidth: 779, width: '100%', marginBottom: 32 }}>
          <Typography
            sx={{ fontSize: 16, fontWeight: 600, marginLeft: 2, marginTop: 2 }}
            color="text.primary"
            gutterBottom
          >
            Dados do Usuário
          </Typography>

          <CardContent
            style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}
          >
            <FormUser
              onChange={changeUserValue}
              formState={userFormState}
              formError={userFormError}
            />
          </CardContent>
        </Card>

        <Card style={{ maxWidth: 779, width: '100%', marginBottom: 32 }}>
          <Typography
            sx={{ fontSize: 16, fontWeight: 600, marginLeft: 2, marginTop: 2 }}
            color="text.primary"
            gutterBottom
          >
            Detalhes da Empresa
          </Typography>

          <CardContent
            style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}
          >
            <FormStore
              onChange={changeValue}
              formState={formState}
              formError={formError}
            />
            <a
              href="#!"
              onClick={() => {
                setOpenDialogChangePassword(true);
              }}
            >
              Alterar senha
            </a>
          </CardContent>
        </Card>
        <Card style={{ maxWidth: 779, width: '100%', marginBottom: 32 }}>
          <Typography
            sx={{ fontSize: 16, fontWeight: 600, marginLeft: 2, marginTop: 2 }}
            color="text.primary"
            gutterBottom
          >
            Endereço
          </Typography>
          <CardContent
            style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}
          >
            <FormAddress
              onChange={changeValue}
              formState={formState}
              formError={formError}
              setFormState={setFormState}
            />
          </CardContent>
        </Card>
        <DivActions>
          <ButtonPrimary.Normal
            label="Deletar conta"
            type="outline"
            width="166px"
            color="#FD4F59"
            onClick={() => {
              setOpenDialog(true);
            }}
          />
          <div style={{ display: 'flex' }}>
            <ButtonPrimary.Normal
              label="Descartar alterações"
              type="outline"
              margin="0 30px 0 0"
              color="#959595"
              onClick={resetForm}
            />
            <ButtonPrimary.Normal
              onClick={async () => {
                if (validateForm()) {
                  await updateStore({
                    userId,
                    store: formStateToGraphqlArgs(formState),
                  });
                }
                if (validateUserForm()) {
                  await updateUser({
                    id: userId,
                    user: userFormState,
                  });
                }
              }}
              label="Salvar alterações"
              width="166px"
            />
          </div>
        </DivActions>
      </FormsDiv>

      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        fullWidth
        maxWidth="sm"
        onClose={() => {
          setOpenDialog(false);
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle
          onClose={() => {
            setOpenDialog(true);
          }}
        >
          Deletar conta
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Tem certeza de que deseja deletar sua conta?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonPrimary.Normal
            label="Cancelar"
            type="outline"
            width="166px"
            color="#323232"
            onClick={() => {
              setOpenDialog(false);
            }}
          />
          <ButtonPrimary.Normal
            label="Confirmar"
            margin="0 30px 0 0"
            color="#013CDB"
            onClick={() => {
              deactivateUserAccount(userId);
              setOpenDialog(false);
            }}
          />
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDialogChangePassword}
        TransitionComponent={Transition}
        keepMounted
        fullWidth
        maxWidth="sm"
        onClose={() => {
          setOpenDialog(false);
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle
          onClose={() => {
            setOpenDialog(true);
          }}
        >
          Alterar Senha
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Você deverá receber um e-mail em breve com mais instruções. Confirma
            o envio de reset de senha para o e-mail cadastrado ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonPrimary.Normal
            label="Cancelar"
            type="outline"
            width="166px"
            color="#323232"
            onClick={() => setOpenDialogChangePassword(false)}
          />
          <ButtonPrimary.Normal
            label="Confirmar"
            margin="0 30px 0 0"
            color="#013CDB"
            onClick={() => {
              changePasswordEmail(userId);
              setOpenDialogChangePassword(false);
            }}
          />
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default Profile;
